<h1 mat-dialog-title>{{data.errorCode}} - Accesso negato</h1>
<div mat-dialog-content>
  <p>{{data.errorDescription}}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="logout()">Chiudi</button>
</div>